import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { parseStatus } from '../../../../../../helpers/constants';
import Box from '../Box';
import * as styled from './style';

const renderStatusTimeline = items => (
  <styled.Timeline>
    {items.map(item => {
      const status = parseStatus(item.idOrderStatus);

      return (
        <styled.Item key={item.id}>
          <styled.Circle
            borderColor={status.borderColor ? status.borderColor : status.bgColor}
            color={status.bgColor}
          />
          <styled.Title>{status.label}</styled.Title>
          <styled.Date>{moment(item.timestampCreation).format('DD/MM/YYYY - HH:mm')}</styled.Date>
        </styled.Item>
      );
    })}
  </styled.Timeline>
);

const BoxStatus = ({ data }) => {
  const status = data.sort((a, b) => a.id - b.id);

  return (
    <Box
      title="Histórico de status"
      size={8}
      customStyles={{ marginTop: 20 }}
      contentStyles={{ paddingTop: 15, paddingBottom: 10 }}
      headerStyles={{ borderBottom: 0, paddingBottom: 0 }}
      content={renderStatusTimeline(status)}
    />
  );
};

BoxStatus.propTypes = {
  data: PropTypes.array,
};

BoxStatus.defaultProps = {
  data: [],
};

export default BoxStatus;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/BoxStatus/index.js